import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  useNavigate,
  Route,
  Routes,
} from "react-router-dom"; // Remove BrowserRouter and useHistory
import Login from "./auth/login.jsx";
import axios from "axios";
import Auth from "./auth/Auth.jsx";
import VerifyEmail from "./auth/VerifyEmail.jsx";
import AdminHome from "./components/Admin/home.jsx";
import AdminProjet from "./components/Admin/projet/Projet.jsx";
import ChercheurHome from "./components/Chercheur/home.jsx";
import ChercheurAbout from "./components/Chercheur/about/About.jsx";
import ChercheurProjet from "./components/Chercheur/projet/Projet.jsx";
import Compte from "./components/Admin/compte/compte.jsx";
import Comptechercheur from "./components/Chercheur/compte/compte.jsx";
import AjouterUnecomp from "./components/Admin/projet/AjouterUneComp.jsx";
import Modification from "./components/Admin/projet/Modification.jsx";
import Forum_projectcherecheur from "./components/Chercheur/forum_Project/Forum_Project.jsx";
import Users from "./components/Admin/users/Users.jsx";
import Comite from "./components/Admin/comite/Comite.jsx";
import Parametre from "./components/Admin/parametre/parametre.jsx";
import Utilistateurs from "./components/Admin/users/Users.jsx";
import UserEdit from "./components/Admin/userEdit/userEdit.jsx";
import AjouterUnBudget from "./components/Admin/parametre/AjouterUnBudget.jsx";
import HomeEvaluateur from "./components/Evaluateur/Home.jsx";
import ProfileSelection from "./components/profileselect/ProfileSelection.jsx";
import ModifierLeBudget from "./components/Admin/parametre/ModifierLeBudget.jsx";
import MyProject from "./components/Chercheur/MyProject/MyProject.jsx";
import Project_Soumi from "./components/Admin/project_soumi/Project_Soumi.jsx";
import Document from "./components/Chercheur/Document/Document.jsx";
import AdminDocument from "./components/Admin/Document/AdminDocument.jsx";
import Compte_evaluateur from "./components/Evaluateur/compte-ev/compte-ev.jsx";
import AjouterUneComite from "./components/Admin/comite/AjouterUneComite.jsx";
import Assigner from "./components/Admin/comite/Assigner.jsx";
import ModifierComite from "./components/Admin/comite/modifierComite.jsx";
import GridEvaluationList from "./components/Admin/GridEvaluation/GridEvaluationList.jsx";
import GridEvaluation from "./components/Admin/GridEvaluation/GridEvaluation.jsx";
import Evaluation from "./components/Evaluateur/Evaluation/Evaluation.jsx";
import ProjectsForCompetition from "./components/Evaluateur/Evaluation/ProjectsForCompetition.jsx";
import ForumEvaluation from "./components/Evaluateur/Evaluation/forum_evaluation";
import PassReset from "./auth/pass_reset.jsx";
import ResetPassword from "./auth/reset_password.jsx";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [role, setRole] = useState(localStorage.getItem("role") || ""); // Retrieve role from localStorage
  const navigate = useNavigate();

  useEffect(() => {
    if (role) {
      setIsLoggedIn(true); // Automatically log in if a role exists
    }
  }, [role]);

  useEffect(() => {
    // Set the base URL for API requests dynamically
    const baseUrl = process.env.REACT_APP_BASE_URL || "http://127.0.0.1/irc/";
    axios.defaults.baseURL = baseUrl;
  }, []);

  const handleLogin = (role) => {
    console.log("Logged in as:", role);
    setIsLoggedIn(true);
    setRole(role.toLowerCase());
    localStorage.setItem("role", role.toLowerCase()); // Save role to localStorage
    if (role.toLowerCase() === "evaluateur") {
      navigate("/select-profile");
    }
  };

  const handleProfileSelect = (profile) => {
    console.log("Profile selected:", profile);
    setRole(profile.toLowerCase());
    localStorage.setItem("role", profile.toLowerCase()); // Save profile to localStorage
    navigate("/home");
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setRole("");
    localStorage.removeItem("role"); // Clear role from localStorage
    navigate("/login");
  };

  return (
    <Routes>
      <Route exact path="/" element={<Login onLogin={handleLogin} />} />
      <Route path="/login" element={<Login onLogin={handleLogin} />} />
      <Route path="/signup" element={<Auth />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/forgot-password" element={<PassReset />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/select-profile"
        element={<ProfileSelection onProfileSelect={handleProfileSelect} />}
      />
      {role === "administrateur" && (
        <>
          <Route path="/home/*" element={<AdminHome />} />
          <Route path="/admin-projet" element={<AdminProjet />} />
          <Route path="/Mon-compte" element={<Compte />} />
          <Route path="/AjouteruneComp" element={<AjouterUnecomp />} />
          <Route path="/ModifierComp" element={<Modification />} />
          <Route path="/ForumProjet" element={<forum_project />} />
          <Route path="/Utilisateurs" element={<Users />} />
          <Route path="/comite" element={<Comite />} />
          <Route path="/parametre" element={<Parametre />} />
          <Route path="/Utilisateurs" element={<Utilistateurs />} />
          <Route path="/UserEdit" element={<UserEdit />} />
          <Route path="/AjouterUnBudget" element={<AjouterUnBudget />} />
          <Route path="/ModifierLeBudget" element={<ModifierLeBudget />} />
          <Route path="/Project_Soumissione" element={<Project_Soumi />} />
          <Route path="/AdminDocument" element={<AdminDocument />} />
          <Route path="/AjouterunComite" element={<AjouterUneComite />} />
          <Route path="/AssignerComite" element={<Assigner />} />
          <Route
            path="/admin-evaluation-grid-list"
            element={<GridEvaluationList />}
          />
          <Route path="/grid-evaluation-new" element={<GridEvaluation />} />
          <Route path="/grid-evaluation-edit/:id" element={<GridEvaluation />} />
          <Route
            path="/modifierComite/:id_comite"
            element={<ModifierComite />}
          />
          <Route path="/AssignerComite/:id_comite" element={<Assigner />} />
          {/* Add a logout button */}
          <Route
            path="/logout"
            element={<button onClick={handleLogout}>Logout</button>}
          />
        </>
      )}
      {role === "chercheur" && (
        <>
          <Route path="/home" element={<ChercheurHome />} />
          <Route path="/chercheur-projet" element={<ChercheurProjet />} />
          <Route path="/chercheur-about" element={<ChercheurAbout />} />
          <Route path="/Mon-compte" element={<Comptechercheur />} />
          <Route
            path="/Forum_ProjectChercheur"
            element={<Forum_projectcherecheur />}
          />
          <Route path="/MyProject" element={<MyProject />} />
          <Route path="/documents" element={<Document />} />
        </>
      )}
      {role === "evaluateur" && (
        <>
          <Route path="/home" element={<HomeEvaluateur />} />
          <Route path="/Mon-compte-ev" element={<Compte_evaluateur />} />
          <Route path="/evaluations" element={<Evaluation />} />
          <Route path="/evaluateur/competitions" element={<Evaluation />} />
          <Route
            path="/evaluateur/competitions/:idcompetition/projets"
            element={<ProjectsForCompetition />}
          />
          <Route
            path="/evaluateur/competitions/:idcompetition/forum"
            element={<ForumEvaluation />}
          />
          <Route
            path="/evaluateur/competitions/:idcompetition/projets/:idprojet/forum"
            element={<ForumEvaluation />}
          />
          {/* Add a logout button */}
        </>
      )}
    </Routes>
  );
};

export default App;
